import { VideoPlay as VideoPlay_filmzi } from './VideoPlay.filmzi';
import { VideoPlay as VideoPlay_kojaro } from './VideoPlay.kojaro';
import { VideoPlay as VideoPlay_phosphor } from './VideoPlay.phosphor';
import { VideoPlay as VideoPlay_zoomg } from './VideoPlay.zoomg';
import { VideoPlay as VideoPlay_zoomit } from './VideoPlay.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'filmzi':
      return VideoPlay_filmzi;

    case 'kojaro':
      return VideoPlay_kojaro;

    case 'zoomg':
      return VideoPlay_zoomg;

    case 'phosphor':
      return VideoPlay_phosphor;

    default:
      return VideoPlay_zoomit;
  }
};

export const VideoPlay = IconRenderer();
